// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"CopyIconButton__wrapper--xo","popup":"CopyIconButton__popup--h6"};